import type { TopicStatus } from "../types";

export function StagePill({ status }: { status: TopicStatus }) {
  return (
    <span className="stage-pill" data-status={status}>
      {status}
    </span>
  );
}
